/* @flow */
import ChatActions from 'chat/actions/ChatActions';
import ChatSettingsActions from '../actions/ChatSettingsActions';
import Columns2 from 'components/Columns2.jsx';
import ConfirmDialog from 'components/ConfirmDialog.jsx';
import CurrentUser from 'auth/CurrentUser';
import Divider from 'components/Divider.jsx';
import Fieldset from 'components/Fieldset.jsx';
import Form from 'components/Form.jsx';
import FormSelect from 'components/FormSelect.jsx';
import Legend from 'components/Legend.jsx';
import OfficeHoursPicker from 'settings/components/OfficeHoursPicker.jsx';
import React from 'react';
import SettingsContainer from './SettingsContainer.jsx';
import ToastActions from 'actions/ToastActions';
import UserActions from 'user/UserActions';
import waitForPromises from 'lib/waitForPromises.jsx';
import { Container } from 'flux/utils';
import { mountModal } from 'lib/modal';

import cx from 'classnames';

import './styles/ChatSettingsView.scss';

class ChatSettingsView extends React.Component {
  static routePrefetch = [
    () => ChatSettingsActions.loadOfficeHours(),
  ]

  static getStores() {
    return [
      CurrentUser,
    ];
  }

  static calculateState = () => {
    const twoWayMessaging = CurrentUser.getUser().hasTwoWayMessaging();

    return {
      twoWayMessaging,
    };
  }

  handleTwoWayMessagingChange = (value) => {
    const twoWayMessaging = value === 'conversations';
    const savePreference = (updateExistingConversations) => {
      const saveOptions = [
        UserActions.savePreference('two_way_messaging', twoWayMessaging),
      ];

      if (updateExistingConversations) {
        saveOptions.push(
          twoWayMessaging ?
            ChatActions.enableRepliesForAllChats() :
            ChatActions.disableRepliesForAllChats()
        );
      }

      Promise.all(saveOptions)
        .then(() => ToastActions.showSuccessToast('Message options have been saved!'))
        .catch(ToastActions.showDefaultErrorToast);
    };

    const modal = (
      <ConfirmDialog
        eventScreenName="ChatSettingsView"
        title={
          twoWayMessaging ?
            '2-way conversations are now turned on!' :
            '1-way announcements are now turned on!'
        }
        subtext={
          twoWayMessaging ?
            `You can now receive messages from class participants. Tap “Update all” to turn on
            replies in your existing conversations.` :
            `This update only applies to new announcements. Tap “Update all” to turn off replies in
            your existing conversations.`
        }
        actionButtonText="Update all"
        cancelButtonText="Not now"
        size="small"
        onConfirm={() => savePreference(true)}
        onCancel={() => savePreference(false)}
      />
    );

    mountModal(modal, this);
  }

  renderMessageOptions() {
    return (
      <Form>
        <Fieldset>
          <Legend>
            Message options
            <p>
              Choose how you would like to communicate with your students and parents.
            </p>
          </Legend>
          <SettingsContainer>
            <Columns2 gutter="small">
              <FormSelect
                name="two_way_messaging"
                value={this.state.twoWayMessaging ? 'conversations' : 'announcements'}
                options={[
                  {
                    value: 'announcements',
                    label: '1-way announcements',
                  },
                  {
                    value: 'conversations',
                    label: '2-way conversations',
                  },
                ]}
                onChange={this.handleTwoWayMessagingChange}
                searchable={false}
              />
            </Columns2>
          </SettingsContainer>
        </Fieldset>
      </Form>
    );
  }

  renderOfficeHours() {
    return (
      <div>
        <Divider />
        <OfficeHoursPicker showToggleButton showToastMessages showIntroText />
      </div>
    );
  }

  render() {
    return (
      <div className={cx('ChatSettingsView', this.props.className)}>
        {this.renderMessageOptions()}
        {this.renderOfficeHours()}
      </div>
    );
  }
}

export default waitForPromises(Container.create(ChatSettingsView));



// WEBPACK FOOTER //
// ./src/settings/components/ChatSettingsView.jsx